import { SxProps, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";

const SlideHeading = ({
    color,
    children,
    style = {},
    sx = {},
}: {
    color: string;
    children: ReactNode;
    style?: any;
    sx?: SxProps<Theme>;
}) => (
    <Typography
        sx={sx}
        style={{
            backgroundColor: color,
            color: "white",
            padding: "2px 5px",
            display: "inline-block",
            ...style,
        }}
        variant="h5"
    >
        {children}
    </Typography>
);

export default SlideHeading;